import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { device } from 'shared/defaultTheme';

import { ReactComponent as CloseIcon } from 'assets/icon-close-round.svg';

export const CustomModalHeader = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 13px;
  height: 57px;
  width: 100%;

  .left-icon-wrapper {
    height: 34px;
    width: 34px;
    margin-right: 14px;
    svg {
      height: 100%;
    }
  }

  .title-label {
    color: ${({ textColor }) => textColor || 'white'};
    letter-spacing: 0;
    line-height: 21px;
    flex: 0.98;
    text-align: ${({ titleCenter }) => (titleCenter ? 'center' : 'left')};
  }

  .title-icon {
    position: absolute;
    left: 49%;
  }
  .div-icon-wrapper {
    height: 45px;
    display: flex;
    justify-content: flex-end;
    @media ${device.sm} {
      width: 37%;
    }
    @media ${device.md} {
      width: 37%;
    }
    @media ${device.lg} {
      width: 75%;
    }
    @media ${device.xl} {
      width: 75%;
    }
  }
  .close-icon-wrapper {
    width: 15px;
    height: 15px;
    border: none;
    background-color: transparent;
    margin-bottom: 5px;
    &:active {
      opacity: 0.5;
    }
    svg {
      fill: white;
      height: 100%;
    }
  }
`;

export const ModalHeader = ({
  className,
  icon,
  label,
  iconTitle,
  backgroundColor,
  titleCenter,
  textColor,
  closeComponent,
  onClose,
  canClose,
}) => (
  <CustomModalHeader
    className={className}
    backgroundColor={backgroundColor}
    titleCenter={titleCenter}
    textColor={textColor}
  >
    <div className="left-icon-wrapper">{icon}</div>
    {iconTitle && <div className="title-icon">{iconTitle}</div>}
    <span className={classNames(['headline', 'title-label'])}>{label}</span>
    {canClose &&
      (closeComponent || (
        <div className="div-icon-wrapper">
          <button className="close-icon-wrapper" type="button" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
      ))}
  </CustomModalHeader>
);

ModalHeader.defaultProps = {
  className: '',
  icon: undefined,
  label: '',
  iconTitle: undefined,
  titleCenter: false,
  textColor: undefined,
  closeComponent: undefined,
  onClose: () => null,
  canClose: true,
};

ModalHeader.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  label: PropTypes.string,
  iconTitle: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  titleCenter: PropTypes.bool,
  textColor: PropTypes.string,
  closeComponent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onClose: PropTypes.func,
  canClose: PropTypes.bool,
};
